import React, { useRef, useState, forwardRef, useImperativeHandle, useCallback, useEffect } from "react";
import MapSearch, { MapSearchRef } from "../../MapSearch";
import { Property, MapSearchContainerProps, MapSearchContainerRef } from "../types";

const MapSearchContainer = forwardRef<MapSearchContainerRef, MapSearchContainerProps>(
  ({ onPropertiesFound, onOwnerDetailsClick, onPropertyReportClick }, ref) => {
    const [properties, setProperties] = useState<Property[]>([]);
    const [searchPerformed, setSearchPerformed] = useState(false);
    const mapSearchRef = useRef<MapSearchRef>(null);

    // Handle properties found from map search
    const handlePropertiesFound = useCallback((foundProperties: Property[]) => {
      // Update state with the new properties
      setProperties(foundProperties);
      setSearchPerformed(true);
      
      // Forward to parent component if prop is provided
      if (onPropertiesFound) {
        onPropertiesFound(foundProperties);
      }
    }, [onPropertiesFound]);

    // Handle location click from results table
    const handleLocationClick = (property: Property) => {
      if (mapSearchRef.current) {
        mapSearchRef.current.handlePropertyLocationClick(property);
      }
    };

    // Expose methods to parent component
    useImperativeHandle(ref, () => ({
      handlePropertyLocationClick: (property: Property) => {
        if (mapSearchRef.current) {
          mapSearchRef.current.handlePropertyLocationClick(property);
        }
      }
    }), []);

    // Render the map search component - results are now shown in a separate tab by the parent component
    return (
      <div className="property-map-search">
        <MapSearch 
          ref={mapSearchRef}
          onPropertiesFound={handlePropertiesFound} 
        />
      </div>
    );
  }
);

// Add display name
MapSearchContainer.displayName = 'MapSearchContainer';

export default MapSearchContainer; 